export default [
    {
      id:514,
      code:'1',
      name:'Statistik Demografi dan Sosial',
      description:'Domain yang berkaitan langsung dengan aktivitas subjek matter untuk menghasilkan data statistik demograsi dan sosial',
      level:1,
      excludes:[],
      parent:null,
    },
    {
      id:519,
      code:'1.1',
      name:'Kependudukan dan Migrasi',
      description:'Mencakup kegiatan statistik yang berkaitan dengan kependudukan dan demografi, topik-topik seperti demografi, statistik vital, struktur dan pertumbuhan populasi, proyeksi demografis, keluarga dan rumah tangga (pernikahan, perceraian, ukuran rumah tangga), migrasi, pengungsi dan pencari suaka. ',
      level:2,
      excludes:[
        {
          subject:{
            code:'1.4',
            name:'Kesehatan',
          },
          items:[
            'Penyebab kematian',
          ]
        }
      ],
      parent:514,
    },
    {
      id:520,
      code:'1.2',
      name:'Ketenagakerjaan',
      description:'Mencakup statistik yang berkaitan dengan angkatan kerja, pasar tenaga kerja, pekerja dan pengangguran; topik yang lebih terperinci termasuk populasi yang aktif secara ekonomi, kondisi tenaga kerja, kesehatan dan keselamatan di tempat kerja (kecelakaan di tempat kerja, cedera dan penyakit akibat kerja, masalah kesehatan terkait pekerjaan), waktu kerja dan kondisi kerja lainnya, pemogokan dan penutupan, lowongan pekerjaan, penciptaan lapangan kerja, penciptaan lapangan kerja.',
      level:2,
      excludes:[
        {
          subject:{
            code:'1.1',
            name:'Kependudukan dan Migrasi',
          },
          items:[
            'Pekerja migran',
          ]
        },
        {
          subject:{
            code:'1.6',
            name:'Perlindungan Sosial',
          },
          items:[
            'Asuransi pengangguran dan tunjangan pengangguran',
          ]
        },
        {
          subject:{
            code:'1.10',
            name:'Aktivitas Politik dan Komunitas lainnya',
          },
          items:[
            'Keanggotaan serikat pekerja',
          ]
        },
        {
          subject:{
            code:'1.11',
            name:'Penggunaan Waktu',
          },
          items:[
            'Pekerjaan yang tidak dibayar',
          ]
        },
        {
          subject:{
            code:'2.8',
            name:'Biaya Tenaga Kerja',
          },
          items:[
            'Biaya tenaga kerja','Statistik pendapatan, upah dan gaji '
          ]
        },
      ],
      parent:514,
    },
    {
      id:521,
      code:'1.3',
      name:'Pendidikan',
      description:'Mencakup partisipasi pendidikan, buta huruf, lembaga dan sistem pendidikan, sumber daya manusia dan keuangan yang diinvestasikan dalam pendidikan, pembelajaran seumur hidup, pelatihan kejuruan dan pembelajaran orang dewasa, dampak pendidikan, penilaian kinerja siswa, dll.',
      level:2,
      excludes:[],
      parent:514,
    },
    {
      id:522,
      code:'1.4',
      name:'Kesehatan',
      description:'Mencakup statistik yang berkaitan dengan kesehatan dan mortalitas, termasuk topik seperti harapan hidup, status kesehatan, kesehatan dan keselamatan, faktor penentu kesehatan (termasuk gaya hidup, nutrisi, merokok, penyalahgunaan alkohol), sumber daya dan pengeluaran kesehatan, sistem perawatan kesehatan, morbiditas dan mortalitas (termasuk kematian bayi dan anak), perawatan di rumah sakit, penyebab penyakit dan kematian, penyakit khusus (misalnya AIDS), cacat tubuh, konsumsi dan penjualan obat-obatan, tenaga kesehatan, penggajian profesi kesehatan, status kesehatan lingkungan, ketidaksetaraan kesehatan, rekening kesehatan.',
      level:2,
      excludes:[
        {
          subject:{
            code:'1.2',
            name:'Ketenagakerjaan',
          },
          items:[
            'Kesehatan dan keselamatan terkait pekerjaan',
          ]
        },
        {
          subject:{
            code:'1.8',
            name:'Peradilan dan Kriminal',
          },
          items:[
            'Korban dari perilaku kriminal',
          ]
        },
        {
          subject:{
            code:'2.4.4',
            name:'Transportasi',
          },
          items:[
            'Kecelakaan dan cedera lalu lintas',
          ]
        },
      ],
      parent:514,
    },
    {
      id:523,
      code:'1.5',
      name:'Pendapatan dan Konsumsi',
      description:'Berkaitan dengan statistik tentang pendapatan dan pengeluaran rumah tangga dari sudut pandang rumah tangga (semua jenis pendapatan dan pengeluaran), termasuk topik-topik seperti distribusi pendapatan, pendapatan dalam bentuk barang, transfer pendapatan yang diterima dan dibayar, pendapatan atau ukuran kemiskinan berbasis pengeluaran, perlindungan konsumen, pola konsumsi , barang konsumen dan barang tahan lama, kekayaan dan hutang rumah tangga.',
      level:2,
      excludes:[
        {
          subject:{
            code:'1.6',
            name:'Perlindungan sosial',
          },
          items:[
            'Skema perlindungan sosial terhadap berbagai risiko',
          ]
        },
        {
          subject:{
            code:'2.5',
            name:'Statistik Keuangan Pemerintah, Fiskal dan Sektor Publik',
          },
          items:[
            'Skema pajak',
          ]
        },
        {
          subject:{
            code:'3.3.1',
            name:'Kondisi tempat tinggal, Kemiskinan',
          },
          items:[
            'Inklusi atau Ekslusi sosial','Kemiskinan dalam arti multidimensi','Kondisi kehidupan',
          ]
        },
      ],
      parent:514,
    },
    {
      id:524,
      code:'1.6',
      name:'Perlindungan Sosial',
      description:'Berkaitan dengan statistik tentang langkah-langkah untuk melindungi orang terhadap risiko pendapatan yang tidak memadai terkait dengan pengangguran, kesehatan yang buruk, ketidakabsahan, usia tua, tanggung jawab orang tua, atau pendapatan yang tidak memadai setelah kehilangan pasangan atau orang tua, dll., termasuk statistik penerima manfaat pensiun, skema jaminan sosial, pengeluaran perlindungan sosial, dll.',
      level:2,
      excludes:[
        {
          subject:{
            code:'2.4.6',
            name:'Perbankan, Asuransi, Statistik Keuangan',
          },
          items:[
            'Dana pensiun sebagai pelaku di pasar keuangan','Perusahaan asuransi sebagai pelaku ekonomi',
          ]
        },
      ],
      parent:514,
    },
    {
      id:525,
      code:'1.7',
      name:'Pemukiman dan Perumahan',
      description:'Mencakup kegiatan statistik yang berkaitan dengan perumahan, tempat tinggal dan pemukiman.',
      level:2,
      excludes:[
        {
          subject:{
            code:'2.7',
            name:'Harga',
          },
          items:[
            'Sewa',
          ]
        },
      ],
      parent:514,
    },
    {
      id:526,
      code:'1.8',
      name:'Peradilan dan Kriminal',
      description:'Aktivitas yang tergolong ke dalam kejahatan, hukuman, pengoperasian sistem peradilan pidana, keadilan, keselamatan, korban, tingkat pembersihan, populasi penjara, produksi obat terlarang, perdagangan dan penggunaan, dll.',
      level:2,
      excludes:[],
      parent:514,
    },
    {
      id:527,
      code:'1.9',
      name:'Kebudayaan',
      description:'Statistik yang berhubungan dengan kegiatan budaya dalam masyarakat, seperti teater, bioskop, museum, perpustakaan, media massa, produksi buku, olahraga, dll., termasuk pengeluaran dan pembiayaan budaya.',
      level:2,
      excludes:[],
      parent:514,
    },
    {
      id:528,
      code:'1.10',
      name:'Aktivitas Politik dan Komunitas lainnya',
      description:'Statistik tentang jumlah pemilih, partisipasi dalam kegiatan politik dan kegiatan masyarakat lainnya, keanggotaan serikat pekerja, dialog sosial, masyarakat sipil, modal sosial, dll.',
      level:2,
      excludes:[],
      parent:514,
    },
    {
      id:529,
      code:'1.11',
      name:'Penggunaan Waktu (Time Use)',
      description:'Statistik tentang penggunaan waktu oleh individu, seringkali terkait dengan keseimbangan kehidupan kerja (rekonsiliasi tanggung jawab keluarga dan pekerjaan berbayar); pekerjaan yang tidak dibayar.',
      level:2,
      excludes:[
        {
          subject:{
            code:'1.2',
            name:'Ketenagakerjaan',
          },
          items:[
            'Waktu kerja',
          ]
        },
      ],
      parent:514,
    },
    {
      id:515,
      code:'2',
      name:'Statistik Ekonomi',
      description:'Domain yang berkaitan langsung dengan aktivitas subjek matter untuk menghasilkan data statistik demograsi dan sosial',
      level:1,
      excludes:[],
      parent:null,
    },
    {
      id:530,
      code:'2.1',
      name:'Statistik Makroekonomi',
      description:'Semua kegiatan yang berhubungan dengan statistik ekonomi di tingkat makro, atau berbeda dari Akun Nasional, baik tahunan, triwulanan atau bulanan. Contohnya adalah basis data ekonomi makro yang menggabungkan akun nasional dan indikator ekonomi makro lainnya seperti Main Economic Indicators (OECD), Principal European Economic Indicators (Eurostat), dll; kecenderungan bisnis dan survei pendapat konsumen, pertumbuhan ekonomi, stabilitas dan penyesuaian struktural, indikator siklus, statistik untuk analisis siklus bisnis.',
      level:2,
      excludes:[
        {
          subject:{
            code:'2.2',
            name:'Neraca Ekonomi',
          },
          items:[
            'Perusahaan asuransi sebagai pelaku ekonomi metodologi dan kerangka kerja akun nasional','Pengumpulan dan penyebaran akun nasional dan data produktivitas yang tidak terkait dengan statistik ekonomi makro lainnya'
          ]
        },
        
      ],
      parent:515,
    },
    {
      id:531,
      code:'2.2',
      name:'Neraca Ekonomi',
      description:'Mencakup kegiatan yang berkaitan dengan pada Neraca Nasional baik harga berlaku maupun harga konstan, berkaitan dengan topik-topik seperti penerapan System National Accounts 1993 (SNA 1993), pembaruan SNA 1993, European System of Accounts (ESA95), Gross Domestic Product (GDP), Gross National Income (GNI), ekonomi non-observasi dan ekonomi informal, pengukuran modal, tabel input-output, neraca, dll.',
      level:2,
      excludes:[
        {
          subject:{
            code:'2.4.1',
            name:'Pertanian, Kehutanan, Perikanan',
          },
          items:[
            'Neraca ekonomi pertanian',
          ]
        },
        {
          subject:{
            code:'2.4.5',
            name:'Pariwisata',
          },
          items:[
            'Neraca satelit pariwisata',
          ]
        },
        {
          subject:{
            code:'2.5',
            name:'Statistik Keuangan Pemerintah, Fiskal dan Sektor Publik',
          },
          items:[
            'Neraca keuangan','Neraca Pemerintah umum (Detailed General Government Accounts)',
          ]
        },
        {
          subject:{
            code:'2.7',
            name:'Harga',
          },
          items:[
            'Statistik harga',
          ]
        },
        {
          subject:{
            code:'3.1',
            name:'Lingkungan Hidup',
          },
          items:[
            'Neraca lingkungan',
          ]
        },
      ],
      parent:515,
    },
    {
      id:532,
      code:'2.3',
      name:'Statistik Bisnis',
      description:'Statistik ekonomi tentang kegiatan perusahaan, mencakup pekerjaan pada statistik ekonomi lintas sektor yang berbeda (berbeda dengan statistik sektoral yang berhubungan dengan sektor individu tertentu), berkaitan pula dengan topik seperti statistik kegiatan ekonomi perusahaan, demografi bisnis, investasi bisnis, layanan bisnis, permintaan untuk layanan, kinerja industri, perusahaan berdasarkan kelas ukuran, produksi industri, komoditas, struktur penjualan dan layanan, output industri jasa, lembaga nirlaba.',
      level:2,
      excludes:[
        {
          subject:{
            code:'2.1',
            name:'Statistik Makroekonomi',
          },
          items:[
            'Survei Tendensi Bisnis',
          ]
        },
        {
          subject:{
            code:'2.6',
            name:'Perdagangan Internasional dan Neraca Pembayaran',
          },
          items:[
            'Perdagangan internasional (2.6 - Perdagangan Internasional dan Neraca Pembayaran',
          ]
        },
        {
          subject:{
            code:'2.7',
            name:'Harga',
          },
          items:[
            'Harga',
          ]
        },
        {
          subject:{
            code:'2.8',
            name:'Biaya Tenaga Kerja',
          },
          items:[
            'Biaya tenaga kerja',
          ]
        },
        {
          subject:{
            code:'2.9',
            name:'Ilmu Pengetahuan, Teknologi dan Inovasi',
          },
          items:[
            'Sains dan teknologi',
          ]
        },
        {
          subject:{
            code:'3.3.3',
            name:'Information Society',
          },
          items:[
            'Teknologi Informasi dan Komunikasi (TIK)',
          ]
        },
        {
          subject:{
            code:'3.3.4',
            name:'Globalisasi',
          },
          items:[
            'Kegiatan afiliasi asing dan perusahaan multinasional',
          ]
        },
      ],
      parent:515,
    },
    {
      id:533,
      code:'2.4',
      name:'Statistik Sektoral',
      description:'kegiatan statistik yang berhubungan dengan salah satu cabang industri atau layanan tertentu yang disebutkan pada tingkat klasifikasi level 3.',
      level:2,
      excludes:[
        {
          subject:{
            code:'1.3',
            name:'Pendidikan',
          },
          items:[
            'Pendidikan',
          ]
        },
        {
          subject:{
            code:'1.4',
            name:'Kesehatan',
          },
          items:[
            'Kesehatan',
          ]
        },
        {
          subject:{
            code:'1.6',
            name:'Perlindungan Sosial',
          },
          items:[
            'Jaminan sosial',
          ]
        },
        {
          subject:{
            code:'1.9',
            name:'Kebudayaan',
          },
          items:[
            'Budaya',
          ]
        },
        {
          subject:{
            code:'2.3',
            name:'Statistik Bisnis',
          },
          items:[
            'Statistik yang mencakup seluruh sektor industri','Statistik yang mencakup seluruh sektor layanan atau layanan pasar','Perdagangan distributif'
          ]
        },
        {
          subject:{
            code:'2.5',
            name:'Statistik Keuangan Pemerintah, Fiskal dan Sektor Publik',
          },
          items:[
            'Statistik pemerintah dan sektor publik'
          ]
        },
        {
          subject:{
            code:'2.9',
            name:'Ilmu Pengetahuan, Teknologi dan Inovasi',
          },
          items:[
            'Penelitian dan pengembangan',
          ]
        },
        {
          subject:{
            code:'3.3.3',
            name:'Information Society',
          },
          items:[
            'Statistik telekomunikasi',
          ]
        },
      ],
      parent:515,
    },
    {
      id:557,
      code:'2.4.1',
      name:'Pertanian, Kehutanan, Perikanan',
      description:'Mencakup semua statistik terkait hortikultura, kehutanan, perikanan, perkebunan, peternakan, dan tanaman pangan, contoh: statistik moneter pertanian (neraca ekonomi pertanian), struktur pertanian (struktur pertanian), perdagangan produk pertanian, input tenaga kerja pertanian, produksi tanaman dan hewan, komoditas pertanian, statistik agroindustri (termasuk produksi dan keamanan pangan), pertanian organik, dan pangan organik , pengeluaran pemerintah untuk pertanian, perikanan dan kehutanan, tabel sumber dan penggunaan produk, statistik hasil hutan dan hutan, penilaian sumber daya hutan dan kebakaran hutan, perdagangan hasil hutan, perikanan.',
      level:3,
      excludes:[
        {
          subject:{
            code:'2.7',
            name:'Harga',
          },
          items:[
            'Harga pertanian dan sejenisnya',
          ]
        },
        {
          subject:{
            code:'3.2',
            name:'Statistik Regional dan Small Area Statistics',
          },
          items:[
            'Pembangunan pedesaan',
          ]
        },
      ],
      parent:533,
    },
    {
      id:558,
      code:'2.4.2',
      name:'Energi',
      description:'Mencakup pasokan energi, penggunaan energi, keseimbangan energi, keamanan pasokan, pasar energi, perdagangan energi, efisiensi energi, sumber energi terbarukan, pengeluaran pemerintah untuk energi.',
      level:3,
      excludes:[
        {
          subject:{
            code:'2.7',
            name:'Harga',
          },
          items:[
            'Harga energi',
          ]
        },
      ],
      parent:533,
    },
    {
      id:559,
      code:'2.4.3',
      name:'Pertambangan, Industri, Konstruksi',
      description:'Statistik tentang kegiatan industri tertentu, contohnya. baja, pembuatan kapal, dan konstruksi, perdagangan produk-produk spesifik yang terkait dengan pertambangan, manufaktur dan konstruksi.',
      level:3,
      excludes:[
        {
          subject:{
            code:'2.7',
            name:'Harga',
          },
          items:[
            'Harga konstruksi','Harga produk yang diproduksi'
          ]
        },
      ],
      parent:533,
    },
    {
      id:560,
      code:'2.4.4',
      name:'Transportasi',
      description:'Mencakup statistik pada semua moda transportasi (udara, kereta api, jalan, jalur air pedalaman, laut), termasuk topik-topik seperti infrastruktur transportasi, peralatan, arus lalu lintas, mobilitas pribadi, keselamatan, konsumsi energi, perusahaan transportasi, angkutan penumpang dan angkutan barang, tren sektor transportasi , kecelakaan lalu lintas jalan.',
      level:3,
      excludes:[
        {
          subject:{
            code:'2.7',
            name:'Harga',
          },
          items:[
            'Harga transportasi',
          ]
        },
      ],
      parent:533,
    },
    {
      id:561,
      code:'2.4.5',
      name:'Pariwisata',
      description:'Mencakup statistik mengenai aktivitas pengunjung (seperti kedatangan / keberangkatan, menginap semalam, pengeluaran, tujuan kunjungan, dll.) yang terkait dengan berbagai bentuk pariwisata (inbound, domestic and outbound), aktivitas dan infrastruktur industri pariwisata, pekerjaan dan akun satelit pariwisata.',
      level:3,
      excludes:[
        {
          subject:{
            code:'2.7',
            name:'Harga',
          },
          items:[
            'Harga untuk layanan wisata',
          ]
        },
        {
          subject:{
            code:'3.1',
            name:'Lingkungan Hidup',
          },
          items:[
            'Dampak lingkungan',
          ]
        },
      ],
      parent:533,
    },
    {
      id:562,
      code:'2.4.6',
      name:'Perbankan, Asuransi, Statistik Keuangan',
      description:'Mencakup statistik uang, perbankan dan pasar keuangan, termasuk rekening keuangan, jumlah uang beredar, suku bunga, nilai tukar, indikator pasar saham, sekuritas, profitabilitas bank, asuransi sektor swasta dan statistik dana pensiun, Indikator Kesehatan Keuangan.',
      level:3,
      excludes:[
        {
          subject:{
            code:'1.6',
            name:'Perlindungan Sosial',
          },
          items:[
            'Penerima manfaat dana pensiun swasta',
          ]
        },
        {
          subject:{
            code:'2.5',
            name:'Statistik Keuangan Pemerintah, Fiskal dan Sektor Publik',
          },
          items:[
            'Pembiayaan pensiun negara dan skema jaminan sosial negara lainnya',
          ]
        },
      ],
      parent:533,
    },
    {
      id:534,
      code:'2.5',
      name:'Statistik Keuangan Pemerintah, Fiskal dan Sektor Publik',
      description:'Mencakup semua statistik yang terkait dengan sektor pemerintah, termasuk utang dan defisit, pendapatan dan pengeluaran, akun sektor pemerintah, pemerintah pusat, tarif pajak dan pendapatan, sistem pajak dan tunjangan, pembiayaan pensiun negara dan skema jaminan sosial negara lainnya, pekerjaan sektor publik.',
      level:2,
      excludes:[
        {
          subject:{
            code:'1.3',
            name:'Pendidikan',
          },
          items:[
            'Pengeluaran pemerintah di bidang pendidikan',
          ]
        },
        {
          subject:{
            code:'1.4',
            name:'Kesehatan',
          },
          items:[
            'Pengeluaran pemerintah di bidang kesehatan',
          ]
        },
        {
          subject:{
            code:'2.9',
            name:'Ilmu Pengetahuan, Teknologi dan Inovasi',
          },
          items:[
            'Pengeluaran pemerintah di bidang penelitian dan pengembangan',
          ]
        },
      ],
      parent:515,
    },
    {
      id:535,
      code:'2.6',
      name:'Perdagangan Internasional dan Neraca Pembayaran',
      description:'Berkaitan dengan statistik pada semua transaksi lintas batas yang dicatat dalam neraca pembayaran, termasuk topik-topik seperti perdagangan barang dan jasa, posisi eksternal dan utang, investasi asing langsung, perdagangan afiliasi asing, tarif, akses pasar, bantuan asing, bantuan pembangunan, aliran sumber daya ke negara berkembang.',
      level:2,
      excludes:[
        {
          subject: null,
          items:[
            'Perdagangan komoditas/jasa tertentu yang disebutkan di subyek 2.4.2 sampai 2.4.5'
          ]
        },
        {
          subject:{
            code:'3.3.4',
            name:'Globalisasi',
          },
          items:[
            'Perusahaan multinasional dan kegiatan afiliasi asing',
          ]
        },
      ],
      parent:515,
    },
    {
      id:536,
      code:'2.7',
      name:'Harga',
      description:'Mencakup setiap kegiatan statistik yang berhubungan dengan harga, termasuk Purchasing Power Parities (PPPs) dan perbandingan internasional PDB, mencakup topik-topik seperti Indeks Harga Konsumen (IHK), inflasi, Indeks Harga Produsen (PPI), indeks harga untuk produk dan layanan tertentu (misalnya Informasi dan produk-produk Teknologi Komunikasi).',
      level:2,
      excludes:[
        {
          subject:{
            code:'2.4.6',
            name:'Perbankan, Asuransi, Statistik keuangan',
          },
          items:[
            'Suku bunga',
          ]
        },
        {
          subject:{
            code:'2.8',
            name:'Biaya Tenaga Kerja',
          },
          items:[
            'Upah',
          ]
        },
      ],
      parent:515,
    },
    {
      id:537,
      code:'2.8',
      name:'Biaya Tenaga Kerja',
      description:'Mencakup kegiatan statistik tentang biaya tenaga kerja, penghasilan dan upah, baik untuk statistik struktural maupun jangka pendek.',
      level:2,
      excludes:[
        {
          subject:{
            code:'1.5',
            name:'Pendapatan dan Konsumsi',
          },
          items:[
            'Upah sebagai bagian dari total pendapatan rumah tangga pribadi',
          ]
        },
      ],
      parent:515,
    },
    {
      id:538,
      code:'2.9',
      name:'Ilmu Pengetahuan, Teknologi dan Inovasi',
      description:'Mencakup Penelitian dan Pengembangan (R&D), inovasi, paten, sumber daya manusia (dalam sains, teknologi dan inovasi), industri teknologi tinggi dan layanan berbasis pengetahuan, bioteknologi, pembiayaan R&D dan inovasi.',
      level:2,
      excludes:[
        {
          subject:{
            code:'3.3.3',
            name:'Information Society',
          },
          items:[
            'Teknologi Informasi dan Komunikasi (TIK)',
          ]
        },
      ],
      parent:515,
    },
    {
      id:516,
      code:'3',
      name:'Statistik Lingkungan Hidup dan Multi-Domain',
      description:'Domain yang berkaitan langsung dengan aktivitas subjek matter untuk menghasilkan data statistik lingkungan hidup dan multi-domain',
      level:1,
      excludes:[],
      parent:null,
    },
    {
      id:539,
      code:'3.1',
      name:'Lingkungan Hidup',
      description:'Termasuk topik seperti iklim, perubahan iklim (termasuk pengukuran aspek sosial-ekonomi dari dampak perubahan iklim, kerentanan dan adaptasi), keanekaragaman hayati, lingkungan dan kesehatan, sumber daya alam, tanah, air, udara, lanskap, limbah, pengeluaran lingkungan, pengeluaran untuk perlindungan lingkungan, neraca lingkungan, indikator lingkungan pertanian, tekanan lingkungan, dampak lingkungan industri, transportasi, energi dll., pemantauan lingkungan, analisis aliran bahan, indikator pelepasan lingkungan, polusi, ekosistem, penggunaan dan tutupan lahan, perlindungan lingkungan , kawasan yang dilindungi secara nasional.',
      level:2,
      excludes:[
        {
          subject:{
            code:'3.3.6',
            name:'Pembangunan Berkelanjutan (SDGs)',
          },
          items:[
            'Lingkungan sebagai bagian dari pembangunan berkelanjutan',
          ]
        },
      ],
      parent:516,
    },
    {
      id:540,
      code:'3.2',
      name:'Statistik Regional dan Small Area Statistics',
      description:'Kegiatan yang berhubungan dengan statistik regional serta statistik yang mengacu pada area sub-nasional atau area berdasarkan unit administratif, statistik perkotaan dan pedesaan, pembangunan pedesaan, akun regional, tipologi regional, dan kesenjangan regional.',
      level:2,
      excludes:[],
      parent:516,
    },
    {
      id:541,
      code:'3.3',
      name:'Statistik dan Indikator Multi-Domain',
      description:'Berkaitan dengan pekerjaan konseptual atau data berdasarkan pendekatan tematik khusus untuk keluaran yang melintasi beberapa bidang ekonomi, sosial atau lingkungan; tingkat dua digit klasifikasi mencakup kegiatan yang berhubungan dengan jenis masalah yang tidak secara eksplisit disebutkan pada tingkat tiga digit.',
      level:2,
      excludes:[
        {
          subject:{
            code:'3.2',
            name:'Statistik Regional dan Small Area Statistics',
          },
          items:[
            'statistik multi-domain berdasarkan pendekatan regional',
          ]
        },
        {
          subject:{
            code:'3.2',
            name:'Buku Tahunan dan Kompedium serupa',
          },
          items:[
            'Jenis buku tahunan kompendium atau produk serupa yg dihasilkan oleh organisasi internasional yang tidak mengikuti pendekatan tematik tertentu',
          ]
        },
      ],
      parent:516,
    },
    {
      id:563,
      code:'3.3.1',
      name:'Kondisi tempat tinggal, Kemiskinan',
      description:'Termasuk aktivitas yang berkaitn dengan metode multidimensi untuk mengukur kemiskinan, kondisi kehidupan dalam arti luas, inklusi / pengecualian sosial, indikator sosial, dan situasi sosial.',
      level:3,
      excludes:[
        {
          subject:{
            code:'1.5',
            name:'Pendapatan dan Konsumsi',
          },
          items:[
            'Pendekatan moneter murni terhadap kemiskinan',
          ]
        },
      ],
      parent:541,
    },
    {
      id:564,
      code:'3.3.2',
      name:'Gender dan Kelompok Populasi Khusus',
      description:'Berkaitan dengan kondisi hidup dan peran kelompok tertentu dalam masyarakat: perbandingan pria / wanita dan situasi kelompok populasi khusus seperti anak-anak, remaja, wanita, orang tua, orang cacat, kelompok minoritas, dll.',
      level:3,
      excludes:[],
      parent:541,
    },
    {
      id:565,
      code:'3.3.3',
      name:'Information Society',
      description:'Statistik yang memungkinkan untuk menilai penggunaan dan dampak teknologi informasi dan komunikasi pada masyarakat, termasuk akses dan penggunaan TIK (termasuk Internet), pengeluaran dan investasi TIK, infrastruktur TIK, jaringan telekomunikasi, komunikasi elektronik, e-government, perdagangan elektronik, e- pembelajaran, penetrasi broadband, layanan TIK, tarif komunikasi, infrastruktur jaringan, pendapatan, pengeluaran dan investasi operator, indikator Internet, perdagangan peralatan telekomunikasi.',
      level:3,
      excludes:[],
      parent:541,
    },
    {
      id:566,
      code:'3.3.4',
      name:'Globalisasi',
      description:'Berurusan dengan mengukur kegiatan ekonomi perusahaan multinasional, serta dengan upaya untuk mengukur globalisasi melalui berbagai komponen dari bidang studi lainnya.',
      level:3,
      excludes:[],
      parent:541,
    },
    {
      id:567,
      code:'3.3.5',
      name:'Indikator yang terkait dengan Tujuan Pembangunan Milenium',
      description:'Berkaitan dengan set indikator untuk memantau pencapaian Tujuan Pembangunan Milenium yang disepakati di KTT Milenium PBB.',
      level:3,
      excludes:[],
      parent:541,
    },
    {
      id:568,
      code:'3.3.6',
      name:'Pembangunan Berkelanjutan (SDGs)',
      description:'Berkaitan dengan indikator dan kerangka kerja untuk memantau dimensi ekonomi, sosial dan lingkungan dari pembangunan berkelanjutan.',
      level:3,
      excludes:[],
      parent:541,
    },
    {
      id:569,
      code:'3.3.7',
      name:'Kewiraswastaan',
      description:'Pengukuran faktor penentu, kinerja dan dampak kegiatan kewirausahaan dari pekerja dan organisasi.',
      level:3,
      excludes:[],
      parent:541,
    },
    {
      id:542,
      code:'3.4',
      name:'Buku Tahunan dan Kompedium serupa',
      description:'Publikasi statistik multi-domain, basis data dan produk data lainnya tanpa berfokus pada tema atau berorientasi pada masalah tertentu.',
      level:2,
      excludes:[
        {
          subject:null,
          items:[
            'Produk statistik multi-domain berdasarkan pendekatan tematik tertentu, seperti pembangunan berkelanjutan (SDGs), MDGs, dll. (3.3.1 sampai 3.3.5).',
          ]
        },
      ],
      parent:516,
    },
  ];